module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.content.title,
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Ce rappel correspond à un rendez-vous.")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "50px"
    },
    attrs: {
      "on-text": "RDV",
      "off-text": "RDV"
    },
    model: {
      value: (_vm.form.meeting),
      callback: function($$v) {
        _vm.$set(_vm.form, "meeting", $$v)
      },
      expression: "form.meeting"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [(!_vm.form.meeting) ? _c('el-form-item', {
    attrs: {
      "prop": "date",
      "label": "Date du rappel"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Selectionnez une date",
      "picker-options": _vm.fields.date,
      "format": "dd/MM/yyyy"
    },
    nativeOn: {
      "click": function($event) {
        _vm.form.date = null;
        _vm.form.date = _vm.moment()
      }
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.meeting) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.form.meeting) ? _c('el-form-item', {
    attrs: {
      "prop": "date",
      "label": "Date et heure du rendez-vous"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-control",
    attrs: {
      "type": "datetime",
      "placeholder": "Selectionnez une date et une heure",
      "picker-options": _vm.fields.date,
      "format": "dd/MM/yyyy à HH:mm"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Durée (en minutes)",
      "prop": "meeting_duration"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": 5
    },
    model: {
      value: (_vm.form.meeting_duration),
      callback: function($$v) {
        _vm.$set(_vm.form, "meeting_duration", $$v)
      },
      expression: "form.meeting_duration"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category_id",
      "label": "Type"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.category_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_id", $$v)
      },
      expression: "form.category_id"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customer_id",
      "label": "Client"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchCustomer,
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.customer_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_id", $$v)
      },
      expression: "form.customer_id"
    }
  }, _vm._l((_vm.fields.customers), function(customer) {
    return _c('customer', {
      key: customer.id,
      attrs: {
        "item": customer,
        "present": "option"
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": "Description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Saisissez la description de votre rappel"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  }), _vm._v(" Plus d'options\n\n      ")])], 1), _vm._v(" "), (_vm.advanced) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Commercial",
      "prop": "user_id"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.user_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_id", $$v)
      },
      expression: "form.user_id"
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.name,
        "value": user.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Mis en avant",
      "prop": "important"
    }
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.important),
      callback: function($$v) {
        _vm.$set(_vm.form, "important", $$v)
      },
      expression: "form.important"
    }
  }, [_vm._v("Non")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.important),
      callback: function($$v) {
        _vm.$set(_vm.form, "important", $$v)
      },
      expression: "form.important"
    }
  }, [_vm._v("Oui")])], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.form.id !== null) ? _c('el-button', {
    directives: [{
      name: "delete",
      rawName: "v-delete:reminder",
      value: (this.form),
      expression: "this.form",
      arg: "reminder"
    }],
    staticClass: "pull-left",
    attrs: {
      "type": "danger",
      "plain": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Supprimer")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.content.button_type
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.content.button))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb09d210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/ReminderModal.vue
// module id = 721
// module chunks = 1